import PropTypes from 'prop-types'

import { ORDER_RELATION_TYPES } from '../../models/orders/order-relation-types-enum.js'
import { idPropType } from '../common/id-prop-type'

/**
 * This is the order relation data model type definition.
 *
 * @typedef {Object} OrderRelation
 * @property {string} orderRelationType - relation type
 * @property {Id} targetOrderId - Id of the related order
 */
export const orderRelationPropType = PropTypes.shape({
    orderRelationType: PropTypes.oneOf(Object.values(ORDER_RELATION_TYPES)),
    targetOrderId: idPropType.isRequired
})
